

// Quick Usage Stats Model
export class QuickUsageStats {
  constructor(data = {}) {
    this.reportsToday = data.reportsToday || 0;
    this.liveReportsToday = data.liveReportsToday || 0;
    this.voiceUploadsToday = data.voiceUploadsToday || 0;
    this.transcriptionsToday = data.transcriptionsToday || 0;
    this.maxReports = data.maxReports || 0;
    this.maxLiveReports = data.maxLiveReports || 0;
    this.maxTranscriptions = data.maxTranscriptions || 0;
    this.planType = data.planType || 'bronze';
    this.resetAt = data.resetAt ? new Date(data.resetAt) : null;
  }
}
